export const WIDGET_REDIRECT_URL = "widget_redirect_url";
